import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NGXLogger } from 'ngx-logger';
import { Subscription } from 'rxjs';
import { DataStorageService } from '../../shared/data-storage.service';
import { PaymentService } from '../Payment.Services';
import { ServiceLinkService } from '../service-links/service-links-service';
import { BillerService, Review, ReviewResponse, ServiceResponse, Summary } from '../services/service-response';

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.css']
})
export class HomePageComponent implements OnInit {
  @ViewChild('widgetsContent') widgetsContent: ElementRef;
  @ViewChild('widgetsContentEdu') widgetsContentEdu: ElementRef;
  @ViewChild('widgetsContentGovt') widgetsContentGovt: ElementRef;
  reviewResponse: ReviewResponse;
  review: Review[] = [];
  summary: Summary[] = [];
  summaryFlag = false;

  constructor(private dataStorageService: DataStorageService,
    private paymentService: PaymentService,
    private logger: NGXLogger,
    private translate: TranslateService,
    public servicelinkService: ServiceLinkService
  ) { }
  subscription: Subscription;
  lang: string;

  ngOnInit() {
    this.reviewResponse = new ReviewResponse();
    this.subscription = this.dataStorageService.langData$.subscribe((data) => {
      this.lang = data;
      if (this.lang == '' || this.lang == null) {
        this.lang = localStorage.getItem('lang');
      }
      this.logger.debug('data lang is ' + this.lang);
      this.translate.use(this.lang);
    });
    this.loadReview();
  }

  loadReview(){
    this.summaryFlag = true;
    this.paymentService.loadReviewlist().subscribe((data) => {
      this.logger.debug('calll>>>>>>', data);
      // debugger;
      this.reviewResponse = data.body as ReviewResponse;
      this.review = this.reviewResponse.review;
      this.summary = this.reviewResponse.summary;
    });
  }


  scrollLeft(){
    this.widgetsContent.nativeElement.scrollLeft -= 120;
  }

  scrollRight(){
    this.widgetsContent.nativeElement.scrollLeft += 120;
    this.logger.debug('data scrollRight is 1', this.widgetsContent.nativeElement.scrollLeft);
  }


  scrollLeftEdu(){
    this.widgetsContentEdu.nativeElement.scrollLeft -= 120;
    this.logger.debug('data scrollLeftEdu is 1', this.widgetsContentEdu.nativeElement.scrollLeft);
  }

  scrollRightEdu(){
    this.widgetsContentEdu.nativeElement.scrollLeft += 120;
  }

  scrollLeftGovt(){
    this.widgetsContentGovt.nativeElement.scrollLeft -= 120;
  }

  scrollRightGovt(){
    this.widgetsContentGovt.nativeElement.scrollLeft += 120;
    this.logger.debug('data scrollRightGovt is 1', this.widgetsContentGovt.nativeElement.scrollLeft);
  }

}



// WEBPACK FOOTER //
// ./src/app/payment/home-page/home-page.component.ts